/**
 * @generated SignedSource<<1864f3683afb401615288682654b0255>>
 * @relayHash 6ba935c14b5de5dce37c6e13535100a2
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/579.0.0-2026-09-25T13:33:30.521Z/setUserPriceBookNameCookieMutation

import { ConcreteRequest } from 'relay-runtime';
export type SetUserPriceBookNameCookieInput = {
  clientMutationId?: string | null;
  cookieDomain?: string | null;
  countryCode?: string | null;
  zipCode?: string | null;
};
export type setUserPriceBookNameCookieMutation$variables = {
  input: SetUserPriceBookNameCookieInput;
};
export type setUserPriceBookNameCookieMutation$data = {
  readonly setUserPriceBookNameCookie: {
    readonly clientMutationId: string | null;
  } | null;
};
export type setUserPriceBookNameCookieMutation = {
  response: setUserPriceBookNameCookieMutation$data;
  variables: setUserPriceBookNameCookieMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetUserPriceBookNameCookiePayload",
    "kind": "LinkedField",
    "name": "setUserPriceBookNameCookie",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "setUserPriceBookNameCookieMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "setUserPriceBookNameCookieMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "ferrum/579.0.0-2026-09-25T13:33:30.521Z/setUserPriceBookNameCookieMutation",
    "metadata": {},
    "name": "setUserPriceBookNameCookieMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "38409ea1d8af209a4c3d5110f23dbfeb";

export default node;
